<div class="p-4">
  <div class="flex justify-between items-center mb-4">

    <div class="flex justify-center items-center gap-3">

        <app-back-button></app-back-button> 

    <h2 class="text-xl font-semibold text-[#3f5f78]">
      {{ 'SETUP.FIN_DATA.VALUES_TITLE' | translate }}
    </h2>
    </div>

    <button
      type="button"
      class="btn-primary"
      (click)="openPopup()"
    >
      {{ 'SETUP.FIN_DATA.ADD_VALUE_BUTTON' | translate }}
    </button>
  </div>

  <app-table
    [data]="list"
    [columns]="columns"
    [actions]="actions">
  </app-table>

  <app-popup
  [(show)]="showPopup"
  [title]="isEditMode ? 'SETUP.FIN_DATA.EDIT_VALUE' : 'SETUP.FIN_DATA.ADD_VALUE'"
  [fields]="fields"
  [data]="formData"
  [type]="'form'"
  [mode]="isEditMode ? 'edit' : 'add'"
  (formSubmit)="handleSave($event)">
</app-popup>

<app-popup
  [(show)]="showDeletePopup"
  title="SETUP.FIN_DATA.DELETE_VALUE"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()">
</app-popup>
</div>